/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react"
import { useToast } from "../../../context/toast-context"
import useAPIHandler from "../../../hook/use-api-handler"
import { logger } from "../../../utils/logger"
import { useAuthContext } from "../../../context/authContext"


const LabourWelfare = () => {

  const { fetchData } = useAPIHandler()
    const [show,setShow]=useState(null)
    const {getOrganizationFn}=useAuthContext()
    const { showToastMessage } = useToast()
    const ToggleFunction=()=>{
        
        LabourWelfareUpdate()
    }


    const LabourWelfareInfo = async () => {
    
        try {
            const response = await fetchData({
                url: "organization-statutory/labour-welfare-fund",
                method: "GET",
              });
             
            if(response){
                setShow(response?.data?.is_allow_lwf)
            }
        } catch (error) {
            logger.log(error)
        }
      };
     
      

    const LabourWelfareUpdate = async () => {


        try {
            const response = await fetchData({
                data:{is_allow_lwf:!show},
                url: "organization-statutory/labour-welfare-fund",
                method: "POST",
              });
            if(response){
                setShow(!show)
                
                showToastMessage({
                    message: `Labour Welfare ${response?.statusCode ? "Update" : "Added"} succesfully!`,
                    color: "success",
                  });
                  getOrganizationFn()

            }
        } catch (error) {
            logger.log(error)
            showToastMessage({
                message: `Something went wrong`,
                color: "danger",
              });
        }
      };

    useEffect(() => {
        LabourWelfareInfo()
    }, [])
    



  return {show,setShow,ToggleFunction}
}

export default LabourWelfare